var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"node-edit__views"},[_c('vueHistyry'),_c('vueHistoryGrace'),_c('vueFilterDate')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }